import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app-container" }
const _hoisted_2 = { class: "conteudo-principal" }

import TarjaDeAcessoComoOutro from "@/components/TarjaDeAcessoComoOutro.vue";
import { useThemeStore } from "@/stores/ThemeStore";
import ConfirmDialog from "primevue/confirmdialog";
import Toast from "primevue/toast";
import { onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const themeStore = useThemeStore();

onMounted(async () => {
  themeStore.initTheme();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TarjaDeAcessoComoOutro),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_unref(ConfirmDialog), { draggable: false }),
    _createVNode(_unref(Toast))
  ]))
}
}

})